// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import INITIAL_STATE from '../orderCreation/initialState.json';

export interface ShippingAddressTypes {
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    language: string;
    addressId: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    country: string;
    stateOrProvince: string;
    vatId: string;
    customerPO: string;
}

export type ShippingAddressStoreType = Readonly<typeof INITIAL_STATE>;

export function _getShippingAddressData(
    state: any,
    { payload }: { payload: any }
): ShippingAddressStoreType {
    if (payload) {
        return {
            ...state,
            shippingAddress: { ...payload },
        };
    }
    return state;
}
